export default "__VITE_ASSET__BYHacJK1__"